import * as React from 'react'

import { encodeQueryString } from '../../queryString'

interface IUseOnSettingsClick {
  openSettingsCallback: () => void
  isPremium: boolean
  page: string
}

/**
 * Hook which provides settings open handler function
 */
export function useOnSettingsClick({ openSettingsCallback, isPremium, page }: IUseOnSettingsClick) {
  const onSettingsClick = React.useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      if (isPremium) {
        openSettingsCallback()
      } else {
        document.location = `/elite.ashx?${encodeQueryString({
          utm_source: 'finviz',
          utm_medium: 'banner',
          utm_campaign: `${page}-settings-button`,
        })}`
      }
    },
    [isPremium, page, openSettingsCallback]
  )
  return onSettingsClick
}
